const emisjaCO2 = { t: 'Emisja CO₂', name: 'emisja-co2', type: 'number', unit: 'g/km' }
export default emisjaCO2